import { render } from "./XchPrice.vue?vue&type=template&id=20e7ecee&scoped=true"
import script from "./XchPrice.vue?vue&type=script&lang=js"
export * from "./XchPrice.vue?vue&type=script&lang=js"

import "./XchPrice.vue?vue&type=style&index=0&id=20e7ecee&scoped=true&lang=css"

import exportComponent from "/Users/fred/Downloads/learn_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e7ecee"]])

export default __exports__